import { LitElement, html } from 'lit'
import { customElement, property, query } from 'lit/decorators.js'
import { style } from './category-chips.style.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { ifDefined } from 'lit/directives/if-defined.js'


initializeIconsByRole({
  'csc-category-chips.left': { name: 'angle-left', style: 'light' },
  'csc-category-chips.right': { name: 'angle-right', style: 'light' },
})

export interface CategoryChip {
  name: string
  url: string
  target?: '_self' | '_blank' | undefined
}

@customElement('csc-category-chips')
export class CSCCategoryChips extends LitElement {
  static override styles = [style]

  @property({ type: Array })
  categories: CategoryChip[] = []

  @query('.chips-container')
  private chipsContainer!: HTMLDivElement

  private scrollContainerLeft() {
    if (this.chipsContainer) {
      this.chipsContainer.scrollBy({ left: -200, behavior: 'smooth' })
    }
  }

  private scrollContainerRight() {
    if (this.chipsContainer) {
      this.chipsContainer.scrollBy({ left: 200, behavior: 'smooth' })
    }
  }

  override render() {
    return html`
      <div class="category-chips-wrapper">
        <cse-icon-button
          class="scroll-btn left"
          aria-label="Scroll left"
          @click=${this.scrollContainerLeft}
          variant="primary"
        >
          <cse-icon icon-role="csc-category-chips.left"></cse-icon>
        </cse-icon-button>
        <div class="chips-container">
          ${this.categories.map(
            cat => html`
              <cse-chip url=${cat.url} target=${ifDefined(cat.target)}>
                ${cat.name}
              </cse-chip>
            `
          )}
        </div>
        <cse-icon-button
          class="scroll-btn right"
          aria-label="Scroll right"
          @click=${this.scrollContainerRight}
          variant="primary"
        >
          <cse-icon icon-role="csc-category-chips.right"></cse-icon>
        </cse-icon-button>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-category-chips': CSCCategoryChips
  }
}
